import { STAIR_DEFAULT_MATERIAL_OVERRIDE } from "building-types/stairs/stairConstruction";
import type { GeneratedStairBlock } from "building-types/stairs/stairTypes";
import type { MaterialSrc } from "common/materials/materialSrc";
import { makeXYPlane } from "doc/measurementUtils";
import { materialSourceOverrideNew } from "doc/utils/materialTools";
import { faceNew, faceMoveAlongNormal } from "geom/brep";
import { extrudePolyLine2AlongNormal } from "geom/extrude";
import type { PolyLine2 } from "geom/polyLine2Types";
import { STAIR_COMPONENT_LANDING } from "./stairExportComponents";

export function addStairLandingPlanOutlineAndExtrusion(
  landingHeight: number,
  riserHeightActual: number,
  outline: PolyLine2,
  blockResult: GeneratedStairBlock,
  landingMaterial?: MaterialSrc,
): void {
  const treadPlane = makeXYPlane(0, 0, landingHeight);
  const landingExtrusion = extrudePolyLine2AlongNormal(outline, treadPlane, -riserHeightActual);
  // bottom face of landing
  blockResult.wallTrimFaces.push(faceMoveAlongNormal(faceNew([outline], treadPlane), -riserHeightActual));

  blockResult.stairPlanPolys.push({ outline, height: landingHeight, outlinesPDF: [], overrideOutlineForPDF: false });

  blockResult.geom.add(
    landingExtrusion,
    landingMaterial
      ? materialSourceOverrideNew(landingMaterial, undefined, STAIR_COMPONENT_LANDING)
      : { ...STAIR_DEFAULT_MATERIAL_OVERRIDE, exportComponentName: STAIR_COMPONENT_LANDING },
  );
}
